import moment from 'moment'

export default (time, startTime = moment().valueOf()) => {
  return moment(time).isSameOrBefore(moment(startTime).subtract(1, 'hour'))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/is_one_hour_before.js
 **/